'use strict'

import axios from 'axios'

const { VUE_APP_COMMS_URL } = process.env

export default async ({ messageId, mailboxType, jwt }) => axios({
  method: 'get',
  headers: {
    Authorization: jwt
  },
  url: `${VUE_APP_COMMS_URL}/${mailboxType}/${messageId}`,
  timeout: 8000
})
